var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}}),_c('span',[_vm._v(_vm._s(_vm.i18n('message')))])])}
var staticRenderFns = []

export { render, staticRenderFns }